import { AuditDisplay } from 'display'
import { DisplayConfig } from 'types'

const config :DisplayConfig[] = [{field: 'url', name: 'Url'}, ...AuditDisplay]

export default config